/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Cancelfailed2Inputs */

const zh_adminsubs_cancelfailed2 = /** @type {(inputs: Adminsubs_Cancelfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消订阅失败`)
};

const en_adminsubs_cancelfailed2 = /** @type {(inputs: Adminsubs_Cancelfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to cancel subscription`)
};

const es_adminsubs_cancelfailed2 = /** @type {(inputs: Adminsubs_Cancelfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al cancelar la suscripción`)
};

/**
* | output |
* | --- |
* | "Failed to cancel subscription" |
*
* @param {Adminsubs_Cancelfailed2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_cancelfailed2 = /** @type {((inputs?: Adminsubs_Cancelfailed2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Cancelfailed2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_cancelfailed2(inputs)
	if (locale === "en") return en_adminsubs_cancelfailed2(inputs)
	return es_adminsubs_cancelfailed2(inputs)
});
export { adminsubs_cancelfailed2 as "adminSubs_cancelFailed" }